export * from './base';
export * from './deviceModel';
export * from './header';
export * from './login';
export * from './region';
export * from './share';
export * from './toNative';
export * from './deviceConnected';
export * from './gotoPage';
export * from "./invokeClient";
// 可以触发任意米家app支持的事件
// 其中detail属性支持自定义参数
export const dispatchEvent = (eventName, data) => {
    window.dispatchEvent(new CustomEvent(eventName, { detail: data }));
    // 关联事件处理，触发了 pageResume 或 appResume 则一定要触发 resume
    if (eventName === 'pageResume' || eventName === 'appResume') {
        window.dispatchEvent(new CustomEvent('resume', { detail: data }));
    }
    // 关联事件处理，触发了 pagePause 或 appPause 则一定要触发 pause
    if (eventName === 'pagePause' || eventName === 'appPause') {
        window.dispatchEvent(new CustomEvent('pause'));
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWlXZWFyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vbGliL21pV2Vhci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxjQUFjLFFBQVEsQ0FBQztBQUN2QixjQUFjLGVBQWUsQ0FBQztBQUM5QixjQUFjLFVBQVUsQ0FBQztBQUN6QixjQUFjLFNBQVMsQ0FBQztBQUN4QixjQUFjLFVBQVUsQ0FBQztBQUN6QixjQUFjLFNBQVMsQ0FBQztBQUN4QixjQUFjLFlBQVksQ0FBQztBQUMzQixjQUFjLG1CQUFtQixDQUFBO0FBQ2pDLGNBQWMsWUFBWSxDQUFBO0FBQzFCLGNBQWMsZ0JBQWdCLENBQUE7QUFFOUIsbUJBQW1CO0FBQ25CLG9CQUFvQjtBQUNwQixNQUFNLENBQUMsTUFBTSxhQUFhLEdBQUcsQ0FBQyxTQUFpQixFQUFFLElBQVMsRUFBRSxFQUFFO0lBQzVELE1BQU0sQ0FBQyxhQUFhLENBQUMsSUFBSSxXQUFXLENBQUMsU0FBUyxFQUFFLEVBQUUsTUFBTSxFQUFFLElBQUksRUFBRSxDQUFDLENBQUMsQ0FBQztJQUVuRSxrREFBa0Q7SUFDbEQsSUFBSSxTQUFTLEtBQUssWUFBWSxJQUFJLFNBQVMsS0FBSyxXQUFXLEVBQUU7UUFDM0QsTUFBTSxDQUFDLGFBQWEsQ0FBQyxJQUFJLFdBQVcsQ0FBQyxRQUFRLEVBQUUsRUFBRSxNQUFNLEVBQUUsSUFBSSxFQUFFLENBQUMsQ0FBQyxDQUFDO0tBQ25FO0lBRUQsK0NBQStDO0lBQy9DLElBQUksU0FBUyxLQUFLLFdBQVcsSUFBSSxTQUFTLEtBQUssVUFBVSxFQUFFO1FBQ3pELE1BQU0sQ0FBQyxhQUFhLENBQUMsSUFBSSxXQUFXLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQztLQUNoRDtBQUNILENBQUMsQ0FBQyJ9